import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'
import {useRefetchOnAliveUpdate} from '../../../hooks/use-refetch-on-alive-update'

export const useAssigneesQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'assignees')

export const useReviewRequestsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'review_requests')

export const useDevelopmentQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'development')

export const useLabelsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'labels')

export const useParticipantsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'participants')

/** Automatically observes for live updates. */
export const useDeploymentsQuery = () => {
  const query = useSuspenseRouteQuery(pullRequestsOverviewRoute, 'deployments')
  useRefetchOnAliveUpdate(query.data.aliveChannel, query.refetch)
  return query
}
